// extracted by mini-css-extract-plugin
export default {"blog":"blog_blog__UQTIR","card":"blog_card__VTJ-1","card1":"blog_card1__al4qi","card2":"blog_card2__7YzgO","post":"blog_post__e3fte"};